import script from "./DefaultCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DefaultCard.vue?vue&type=script&setup=true&lang=js"

import "./DefaultCard.vue?vue&type=style&index=0&id=6907192c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6907192c"]])

export default __exports__